export function EnforceSSL(url: string|undefined) {
    let fixedUrl = url;
    if (fixedUrl) {
        fixedUrl = fixedUrl.replace(/http:\/\//i, 'https://');
    }    
    return fixedUrl;
}